import { AnyAction, ListenerEffectAPI, ThunkDispatch } from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { getCampaignReports } from '../thunks/get-campaign-reports.thunk';

export const CampaignReportsListenerEffect = (
  action: AnyAction,
  api: ListenerEffectAPI<
    AppRootState,
    ThunkDispatch<AppRootState, undefined, AnyAction>,
    unknown
  >
): void => {
  const campaignId = api.getState().campaignsFeature.vehicleReports.campaignId;

  const paginationParams =
    api.getState().campaignsFeature.vehicleReports.pagination;

  api.dispatch(
    getCampaignReports({ entityId: campaignId, pagination: paginationParams })
  );
};
